import React from 'react';

const ExplainPasswordlessModalLink = () => (
  <a className="login-help-link" data-toggle="modal" data-target=".modal">
    What&apos;s a security code?
  </a>
);

export default ExplainPasswordlessModalLink;
